import getAuditTrailRequest from '@domain/model/request/auditTrail/getAuditTrail';
import getAuditTrail from '@hooks/auditTrail/getAuditTrail';

const useGetAuditTrail = (filters) => {
    const queries = getAuditTrailRequest(filters);

    return getAuditTrail({ queries });
};

export default useGetAuditTrail;
